import type { PublicAppointmentContactCompletion } from "../../../../../../../../../api/public/appointment-portal"

export const contactCompletionIntroduction = (
  availability: PublicAppointmentContactCompletion,
): string => {
  if (availability.email === "unknown" || availability.phone === "unknown") {
    return "Möchten Sie Ihre Kontaktdaten für Rückfragen und die nächste Terminabstimmung ergänzen?"
  }

  if (availability.email === "missing" && availability.phone === "missing") {
    return "Zu Ihren Angaben ist bei uns noch keine E-Mail-Adresse oder Telefonnummer hinterlegt. Ergänzen Sie gerne einen Kontaktweg."
  }

  return availability.email === "missing"
    ? "Zu Ihren Angaben ist bei uns noch keine E-Mail-Adresse hinterlegt. Ergänzen Sie diese gerne für die nächste Terminabstimmung."
    : "Zu Ihren Angaben ist bei uns noch keine Telefonnummer hinterlegt. Ergänzen Sie diese gerne für Rückfragen und die nächste Terminabstimmung."
}
